import { useState, useEffect } from 'react';
import { Close as CloseIcon } from '@mos-cat/ds-icons';
import { SystemStyleObject } from '@styled-system/css';
import { Box } from '../../Box/Box';
import { UtilityButton } from '../../UtilityButton/UtilityButton';
import { Message } from '../../Message/Message';
import { Text } from '../../Text/Text';

type Props = {
  kind: Parameters<typeof Message>[0]['kind'];
  visibilityCondition: boolean | number;
  message: string;
};

function InnerMessage({ kind, visibilityCondition, message }: Props) {
  const [isMessageVisible, setIsMessageVisible] = useState(false);
  useEffect(() => {
    setIsMessageVisible(Boolean(visibilityCondition));
  }, [visibilityCondition]);
  const handleButtonCloseClick = () => {
    setIsMessageVisible(false);
  };
  if (!isMessageVisible) return null;

  return (
    <Box my="sp-24">
      <Message kind={kind}>
        <Box display="flex">
          <Text
            as={Box}
            role="alert"
            aria-live="assertive"
            fontSize="fileUploaderMessageFontSize"
            pr={['sp-0', 'fileUploaderMessagePaddingRight']}
          >
            {message}
          </Text>
          <UtilityButton
            aria-label="Закрыть уведомление"
            styles={
              {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 'button',
                size: 'fileUploaderMessageBtnSize',
                position: 'absolute',
                right: [
                  'fileUploaderMessageBtnRightOffset',
                  'fileUploaderMessageBtnRightOffsetBig',
                ],
                top: [
                  'fileUploaderMessageBtnTopOffset',
                  'fileUploaderMessageBtnTopOffsetBig',
                ],
                color: 'fileUploaderMessageBtnColor',

                '&:hover': {
                  color: 'fileUploaderMessageBtnHoverColor',
                },

                '&:active': {
                  color: 'fileUploaderMessageBtnActiveColor',
                },

                '&:focus': {
                  boxShadow: 'focus',
                },
              } as SystemStyleObject
            }
            onClick={handleButtonCloseClick}
          >
            <Box as={CloseIcon} size="fileUploaderMessageBtnIconSize" />
          </UtilityButton>
        </Box>
      </Message>
    </Box>
  );
}

export default InnerMessage;
